// extracted by mini-css-extract-plugin
module.exports = {"towelAccessory":"AvatarOnBeachTowel_towelAccessory__ZbPLY"};